import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageValidation from '@/icons/PackageValidation.svg';

export const ArticleSelfHandledTransitCompletedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_self_handled_transit_completed'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator?.name;
  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackageValidation />}
      message={
        <>
          <BaseActivityText>
            <Trans id="activities.article_self_handled_transit_completed.message-item">
              <strong>{creatorName}</strong> confirmed reception of the item {articleName}
            </Trans>
          </BaseActivityText>
        </>
      }
    />
  );
};
